import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetOperationsReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_REPLENISHMENT_OPERATIONS_GGR
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetOperationsReplenishmentAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetOperationsReplenishment as SetGetOperationsReplenishment
}